const selectedFilters = {};
const customerFavouriteVendor = window.customer_caseificio_preferito;
const currentMarketHandle = Shopify.country?.toLowerCase() || "it";
let currentHitsPerPage = 12;

const marketAttributeMap = {
  at: "meta.custom.included_austria",
  fr: "meta.custom.included_francia",
  de: "meta.custom.included_germania",
  it: "meta.custom.included_italy",
  lu: "meta.custom.included_lussemburgo",
  nl: "meta.custom.included_olanda",
  es: "meta.custom.included_spain",
  be: "meta.custom.included_belgio",
};

const uiTranslations = {
  "FILTRI ATTIVI": {
    it: "FILTRI ATTIVI",
    en: "ACTIVE FILTERS",
    de: "AKTIVE FILTER",
    fr: "FILTRES ACTIFS",
    nl: "ACTIEVE FILTERS",
    es: "FILTROS ACTIVOS",
    be: "ACTIEVE FILTERS",
  },
  "Rimuovi tutti": {
    it: "Rimuovi tutti",
    en: "Remove all",
    de: "Alle entfernen",
    fr: "Tout supprimer",
    nl: "Alles verwijderen",
    es: "Eliminar todos",
    be: "Alles verwijderen",
  },
  "Risultati di ricerca per": {
    it: "Risultati di ricerca per",
    en: "Search results for",
    de: "Suchergebnisse für",
    fr: "Résultats de recherche pour",
    nl: "Zoekresultaten voor",
    es: "Resultados de búsqueda para",
    be: "Zoekresultaten voor",
  },
  "Prezzo più basso recente": {
    it: "Prezzo più basso recente",
    en: "Recent lowest price",
    de: "Niedrigster Preis vor kurzem",
    fr: "Prix le plus bas récent",
    nl: "Recente laagste prijs",
    es: "Precio más bajo reciente",
    be: "Recente laagste prijs",
  },
  "Prezzo iniziale": {
    it: "Prezzo iniziale",
    en: "Original price",
    de: "Ursprünglicher Preis",
    fr: "Prix initial",
    nl: "Oorspronkelijke prijs",
    es: "Precio inicial",
    be: "Oorspronkelijke prijs",
  },
  "Nessun risultato trovato": {
    it: "Nessun risultato trovato",
    en: "No results found",
    de: "Keine Ergebnisse gefunden",
    fr: "Aucun résultat trouvé",
    nl: "Geen resultaten gevonden",
    es: "No se encontraron resultados",
    be: "Geen resultaten gevonden",
  },
  "Prezzo più basso recente": {
    it: "Prezzo più basso recente",
    en: "Recent lowest price",
    de: "Niedrigster Preis vor kurzem",
    fr: "Prix le plus bas récent",
    nl: "Recente laagste prijs",
    es: "Precio más bajo reciente",
    be: "Recente laagste prijs",
  },
  "Grandi formati": {
    it: "Grandi formati",
    en: "Large formats",
    de: "Große Formate",
    fr: "Grands formats",
    nl: "Grote formaten",
    es: "Grandes formatos",
    be: "Grote formaten",
  },
  "Rimuovi filtro": {
    it: "Rimuovi filtro",
    en: "Remove filter",
    de: "Filter entfernen",
    fr: "Supprimer le filtre",
    nl: "Filter verwijderen",
    es: "Eliminar filtro",
    be: "Filter verwijderen",
  },
  "Cerca...": {
    it: "Cerca...",
    en: "Search...",
    de: "Suchen...",
    fr: "Rechercher...",
    nl: "Zoeken...",
    es: "Buscar...",
    be: "Zoeken...",
  },
  // facets
  Caseificio: {
    it: "Caseificio",
    en: "Dairy",
    de: "Molkerei",
    fr: "Fromagerie",
    nl: "Zuivelfabriek",
    es: "Quesería",
    be: "Zuivelfabriek",
  },
  Formato: {
    it: "Formato",
    en: "Format",
    de: "Format",
    fr: "Format",
    nl: "Formaat",
    es: "Formato",
    be: "Formaat",
  },
  "Stagionatura minima": {
    it: "Stagionatura minima",
    en: "Minimum aging",
    de: "Mindestreifezeit",
    fr: "Affinage minimum",
    nl: "Minimale rijping",
    es: "Maduración mínima",
    be: "Minimale rijping",
  },
  Biodiversità: {
    it: "Biodiversità",
    en: "Biodiversity",
    de: "Biodiversität",
    fr: "Biodiversité",
    nl: "Biodiversiteit",
    es: "Biodiversidad",
    be: "Biodiversiteit",
  },
  "Grandi formati": {
    it: "Grandi formati",
    en: "Large formats",
    de: "Große Formate",
    fr: "Grands formats",
    nl: "Grote formaten",
    es: "Formatos grandes",
    be: "Grote formaten",
  },
  "Tipo Prodotto": {
    it: "Tipo prodotto",
    en: "Product type",
    de: "Produkttyp",
    fr: "Type de produit",
    nl: "Producttype",
    es: "Tipo de producto",
    be: "Producttype",
  },
  // facet values
  // Stagionatura
  "12-19 mesi": {
    it: "12-19 mesi",
    en: "12-19 months",
    de: "12-19 Monate",
    fr: "12-19 mois",
    nl: "12-19 maanden",
    es: "12-19 meses",
    be: "12-19 maanden",
  },
  "20-26 mesi": {
    it: "20-26 mesi",
    en: "20-26 months",
    de: "20-26 Monate",
    fr: "20-26 mois",
    nl: "20-26 maanden",
    es: "20-26 meses",
    be: "20-26 maanden",
  },
  "27-34 mesi": {
    it: "27-34 mesi",
    en: "27-34 months",
    de: "27-34 Monate",
    fr: "27-34 mois",
    nl: "27-34 maanden",
    es: "27-34 meses",
    be: "27-34 maanden",
  },
  "34-45 mesi": {
    it: "34-45 mesi",
    en: "34-45 months",
    de: "34-45 Monate",
    fr: "34-45 mois",
    nl: "34-45 maanden",
    es: "34-45 meses",
    be: "34-45 maanden",
  },
  "35-45 mesi": {
    it: "35-45 mesi",
    en: "35-45 months",
    de: "35-45 Monate",
    fr: "35-45 mois",
    nl: "35-45 maanden",
    es: "35-45 meses",
    be: "35-45 maanden",
  },
  "46-79 mesi": {
    it: "46-79 mesi",
    en: "46-79 months",
    de: "46-79 Monate",
    fr: "46-79 mois",
    nl: "46-79 maanden",
    es: "46-79 meses",
    be: "46-79 maanden",
  },
  "oltre 80 mesi": {
    it: "oltre 80 mesi",
    en: "over 80 months",
    de: "über 80 Monate",
    fr: "plus de 80 mois",
    nl: "meer dan 80 maanden",
    es: "más de 80 meses",
    be: "meer dan 80 maanden",
  },
  // Biodiversità
  Classico: {
    it: "Classico",
    en: "Classic",
    de: "Klassisch",
    fr: "Classique",
    nl: "Klassiek",
    es: "Clásico",
    be: "Klassiek",
  },
  Biologico: {
    it: "Biologico",
    en: "Biological",
    de: "Bio",
    fr: "Biologique",
    nl: "Biologisch",
    es: "Biológico",
    be: "Biologisch",
  },
  "Vacche rosse": {
    it: "Vacche rosse",
    en: "Red cows",
    de: "Rote Kühe",
    fr: "Vaches rouges",
    nl: "Rode koeien",
    es: "Vacas rojas",
    be: "Rode koeien",
  },
  "Vacca bruna": {
    it: "Vacca bruna",
    en: "Brown cow",
    de: "Braunvieh",
    fr: "Vache brune",
    nl: "Bruine koe",
    es: "Vaca parda",
    be: "Bruine koe",
  },
  "Prodotto di montagna": {
    it: "Prodotto di montagna",
    en: "Mountain product",
    de: "Bergprodukt",
    fr: "Produit de montagne",
    nl: "Bergproduct",
    es: "Producto de montaña",
    be: "Bergproduct",
  },
  "Vacca bianca": {
    it: "Vacca bianca",
    en: "White cow",
    de: "Weiße Kuh",
    fr: "Vache blanche",
    nl: "Witte koe",
    es: "Vaca blanca",
    be: "Witte koe",
  },
  // Formato
  "Ottavo di forma": {
    it: "Ottavo di forma",
    en: "Eighth of wheel",
    de: "Achtel Laib",
    fr: "Huitième de meule",
    nl: "Achtste van het wiel",
    es: "Octavo de rueda",
    be: "Achtste van het wiel",
  },
  "Mezza forma": {
    it: "Mezza forma",
    en: "Half wheel",
    de: "Halber Laib",
    fr: "Demi-meule",
    nl: "Half wiel",
    es: "Media rueda",
    be: "Half wiel",
  },
  "Quarto di forma": {
    it: "Quarto di forma",
    en: "Quarter wheel",
    de: "Viertel Laib",
    fr: "Quart de meule",
    nl: "Kwart wiel",
    es: "Cuarto de rueda",
    be: "Kwart wiel",
  },
  Forma: {
    it: "Forma",
    en: "Whole wheel",
    de: "Ganzer Laib",
    fr: "Meule entière",
    nl: "Heel wiel",
    es: "Rueda entera",
    be: "Heel wiel",
  },
  // Tipo prodotto
  "Carte Regalo": {
    it: "Carte Regalo",
    en: "Gift Cards",
    de: "Geschenkkarten",
    fr: "Cartes cadeaux",
    nl: "Cadeaubonnen",
    es: "Tarjetas regalo",
    be: "Cadeaubonnen",
  },
};

// Funzione per tradurre elementi UI
function translateUI(key) {
  const currentLocale = Shopify.locale || "it";
  const translations = uiTranslations[key];

  if (translations && translations[currentLocale]) {
    return translations[currentLocale];
  }

  return key;
}

function getOriginalValue(translatedValue) {
  const currentLocale = Shopify.locale || "it";

  // Se siamo già in italiano, ritorna il valore così com'è
  if (currentLocale === "it") return translatedValue;

  // Cerca nelle traduzioni il valore originale italiano
  for (const [originalItalian, translations] of Object.entries(
    uiTranslations
  )) {
    if (translations[currentLocale] === translatedValue) {
      return originalItalian; // Ritorna il valore italiano originale
    }
  }

  // Se non trova nulla, ritorna il valore passato (probabilmente è un vendor/caseificio)
  return translatedValue;
}

function handleize(str) {
  return str
    .toLowerCase()
    .normalize("NFD") // rimuove accenti
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function renderHits(hits) {
  const container = document.querySelector(".ais-hits-container");
  const partialContainer = document.getElementById("algolia-partial-count");

  if (partialContainer) {
    partialContainer.innerHTML = hits.length + " ";
  }

  if (!container) return;

  if (customerFavouriteVendor) {
    hits.sort((a, b) => {
      const aIsFav = a.vendor === customerFavouriteVendor;
      const bIsFav = b.vendor === customerFavouriteVendor;

      if (aIsFav && !bIsFav) return -1;
      if (!aIsFav && bIsFav) return 1;
      return 0;
    });
  }
  if (hits.length === 0) {
    const fallBackContainer = document.getElementById(
      "algolia-fallback-container"
    );
    const paginationButton = document.getElementById("load-more-products");
    paginationButton.style.display = "none";
    fallBackContainer.innerHTML =
      '<div style="text-align: center;"  class="algolia-no-results"><p >' +
      translateUI("Nessun risultato trovato") +
      "</p></div>";
  } else {
    const fallBackContainer = document.getElementById(
      "algolia-fallback-container"
    );
    fallBackContainer.style.display = "none";
  }

  container.innerHTML = hits
    .map((hit) => {
      const badges = Array.isArray(hit.meta?.custom?.marchi_stagionatura)
        ? hit.meta.custom.marchi_stagionatura
        : [];
      const hitImage = hit._highlightResult?.image?.value || hit.image || "";
      const hitLargeFormat = hit.meta?.custom?.grandi_formati;

      let formatoGrandeTag = "";
      if (hitLargeFormat) {
        formatoGrandeTag = `<div class="algolia-card-product-tag">${window.largeFormatsLabel}</div>`;
      }

      let prezzoRecenteHtml = "";
      const minPrice = hit.meta?.custom?.omnibus_min_price;
      const discount = hit.meta?.custom?.omnibus_discount_percentage;
      if (minPrice || discount) {
        prezzoRecenteHtml = `
        <div class="algolia-last-best-price">
          ${translateUI("Prezzo più basso recente")}:
          <span class="algolia-value">€${parseFloat(minPrice).toFixed(2)}</span>
          <span class="algolia-percentage">${discount ?? ""}</span>
        </div>`;
      }

      // Discount block (compare_at_price logic)
      let discountBlock = "";
      const price =
        Shopify.locale === "it"
          ? hit.meta?.custom?.prezzo_catalogo_ita
          : hit.meta?.custom?.prezzo_catalogo_eu;
      const comparePrice =
        Shopify.locale === "it"
          ? hit.meta?.custom?.prezzo_compare_catalogo_ita
          : hit.meta?.custom?.prezzo_compare_catalogo_eu;
      if (
        typeof comparePrice === "number" &&
        typeof price === "number" &&
        comparePrice > price &&
        comparePrice > 0
      ) {
        const discountValue = comparePrice - price;
        const discountPercentage = Math.round(
          (discountValue * 100) / comparePrice
        );
        discountBlock = `
          <div class="algolia-last-best-price" style="margin-top: ${
            hit.vendor.length > 20 ? "-5px" : "15px"
          };">
            ${translateUI("Prezzo iniziale")}:
            <span class="algolia-value">€${comparePrice.toFixed(2)}</span>
            <span class="algolia-percentage"> - ${discountPercentage}%</span>
          </div>
        `;
      }

      let pesoFormattato = "";
      let afterWeigt = hitLargeFormat ? "min" : "";
      const rawPeso = hit.weight;
      if (typeof rawPeso === "string") {
        const pesoMatch = rawPeso.match(/^([\d.]+)([a-zA-Z]+)$/);
        if (pesoMatch) {
          let num = parseFloat(pesoMatch[1]);
          if (num % 1 !== 0) {
            num = num.toFixed(1).replace(".", ",");
          } else {
            num = num.toString();
          }
          const unit = pesoMatch[2];
          pesoFormattato = `${num}${unit}`;
        } else {
          pesoFormattato = rawPeso;
        }
      } else if (typeof rawPeso === "number") {
        if (rawPeso % 1 !== 0) {
          pesoFormattato = `${rawPeso.toFixed(1).replace(".", ",")}g`;
        } else {
          pesoFormattato = `${rawPeso}g`;
        }
      }

      pesoFormattato = pesoFormattato + " " + afterWeigt;

      const productLink = algoliaShopify.helpers.instantsearchLink(hit);

      const badgeImgs = badges
        .map((badge) => {
          const url = window.assetBadgeMap?.[badge] || "";
          return url
            ? `<img src="${url}" alt="${badge}" class="algolia-badge-image" loading="lazy" width="64" height="64" />`
            : "";
        })
        .join("");

      function handleize(str) {
        return str
          .toLowerCase()
          .normalize("NFD") // rimuove accenti
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      }

      const vendorLink = `${window.collectionsBaseUrl}/${handleize(
        hit.vendor
      )}`;

      const prezzoProdotto = algoliaShopify.helpers.displayPrice(
        hit,
        hit._distinct
      );
      const prezzoEu =
        hit?.meta?.custom?.prezzo_catalogo_eu < 0
          ? ""
          : `€${parseFloat(hit?.meta?.custom?.prezzo_catalogo_eu).toFixed(
              2
            )}`.replace(".", ",");
      const rawPrezzoIta = hit?.meta?.custom?.prezzo_catalogo_ita;
      const prezzoIta =
        typeof rawPrezzoIta === "number" && rawPrezzoIta >= 0
          ? `€${rawPrezzoIta.toFixed(2).replace(".", ",")}`
          : prezzoProdotto;
      const titoloProdotto = hit.title;
      let prezzoAlKg = "";
      const weight = hit.grams;
      const finalPrice =
        Shopify.locale === "it"
          ? hit?.meta?.custom?.prezzo_catalogo_ita
          : hit?.meta?.custom?.prezzo_catalogo_eu;
      if (
        hit.product_type !== "kit" &&
        typeof weight === "number" &&
        weight > 0 &&
        typeof finalPrice === "number" &&
        finalPrice > 0
      ) {
        const prezzoAlKgNum = (finalPrice * 1000) / weight;
        prezzoAlKg = `${prezzoAlKgNum.toFixed(2).replace(".", ",")}€/kg`;
      }
      const vendorName = hit.vendor;

      return `
      <div class="algolia-pr-card-wrapper">
        <div class="algolia-card-product-badges">${badgeImgs}</div>
        <div class="algolia-card-product algolia-hidden algolia-fade-in"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
        <div class="algolia-card-body">
          <a  href="${productLink}">
            <img
              class="algolia-card-product-img"
              src="${hitImage}"
              alt="${titoloProdotto}"
              width="100%"
              height="100%"
            />
          </a>

          ${formatoGrandeTag}

          <div class="algolia-product-card-info">
            <div class="algolia-card-product-vendor">
              <a href="${vendorLink}">${vendorName}</a>
            </div>

            <div class="algolia-card-product-title">
              <a href="${productLink}">${titoloProdotto}</a>
            </div>

        <div class="algolia-price-per-kg">${prezzoAlKg}</div>
            ${prezzoRecenteHtml}
            ${discountBlock}
          </div>
        </div>
          <div class="algolia-card-product-bottom">
            <div class="algolia-product-price">${
              Shopify.locale === "it" ? prezzoIta || "" : prezzoEu
            }</div>
            <div class="algolia-product-weight">${
              hit.meta?.custom?.tipo_prodotto == "Carte Regalo"
                ? ""
                : pesoFormattato
            }</div>
          </div>

          <button
            class="algolia-add-to-cart-button add-to-cart-button"
            type="button"
            data-product-id="${hit.id}"
            data-variant-id="${hit.objectID}"
          >
            ${window.addToCart}
          </button>
        </div>
      </div>
    `;
    })
    .join("");
}

function getCurrentSortIndex() {
  const nativeSelect = document.querySelector(
    ".ais-sort-orders-container select"
  );
  if (nativeSelect && nativeSelect.value) {
    return nativeSelect.value;
  }
  return window.algoliaShopify?.instantsearch?.search?.indexName || "products";
}

function fetchAndRenderHits() {
  currentHitsPerPage = 12;

  const searchClient = window.algoliaShopify?.instantsearch?.search?.client;
  if (!searchClient) return;

  const indexName = getCurrentSortIndex();

  const queryInput = document.querySelector(
    ".ais-search-box input, .ais-SearchBox-input"
  );
  const query = queryInput
    ? queryInput.value.trim()
    : new URLSearchParams(window.location.search).get("q") || "";

  const filtersArray = [];
  Object.entries(selectedFilters).forEach(([facetName, values]) => {
    if (Array.isArray(values) && values.length) {
      const escapedValues = values.map((v) => String(v).replace(/"/g, '\\"'));
      filtersArray.push(
        `(${escapedValues.map((v) => `${facetName}:"${v}"`).join(" OR ")})`
      );
    }
  });

  const marketAttribute = marketAttributeMap[currentMarketHandle];
  if (marketAttribute) {
    filtersArray.push(`${marketAttribute}:true`);
  }

  const collectionFilter = window.currentCollectionFilter || null;
  if (collectionFilter) {
    filtersArray.push(collectionFilter);
  }
  const baseFilters = filtersArray.join(" AND ");

  const vendor = customerFavouriteVendor || null;
  const escVendor = vendor ? String(vendor).replace(/"/g, '\\"') : null;

  const queries = [];

  if (escVendor) {
    const hasVendorInBase = /(^|\s|\()vendor:/.test(baseFilters);
    const vendorFilters = baseFilters
      ? hasVendorInBase
        ? baseFilters
        : `(${baseFilters}) AND vendor:"${escVendor}"`
      : `vendor:"${escVendor}"`;

    queries.push({
      indexName,
      params: {
        query,
        filters: vendorFilters,
        hitsPerPage: currentHitsPerPage,
      },
    });
  }

  queries.push({
    indexName,
    params: {
      query,
      filters: baseFilters || "",
      hitsPerPage: currentHitsPerPage,
    },
  });

  searchClient
    .search(queries)
    .then(({ results }) => {
      let merged = [];
      let nbHits = 0;

      if (escVendor) {
        const vendorHits = results[0]?.hits || [];
        const mainRes = results[1];
        const mainHits = mainRes?.hits || [];

        const seen = new Set();
        const pushUnique = (arr) => {
          for (const h of arr) {
            const id =
              h.objectID ||
              h.objectId ||
              h.id ||
              `${h.vendor}-${h.handle || h.title}`;
            if (!seen.has(id)) {
              seen.add(id);
              merged.push(h);
            }
          }
        };

        pushUnique(vendorHits);
        pushUnique(mainHits);

        merged = merged.slice(0, currentHitsPerPage);

        nbHits =
          typeof mainRes?.nbHits === "number" ? mainRes.nbHits : merged.length;
      } else {
        const mainRes = results[0];
        merged = (mainRes?.hits || []).slice(0, currentHitsPerPage);
        nbHits =
          typeof mainRes?.nbHits === "number" ? mainRes.nbHits : merged.length;
      }

      renderHits(merged);

      const resultsContainer = document.getElementById("algolia-results-count");
      if (resultsContainer) resultsContainer.textContent = " " + nbHits;

      const loadMoreButton = document.querySelector("#load-more-products");
      if (loadMoreButton) {
        loadMoreButton.style.display =
          currentHitsPerPage >= nbHits ? "none" : "block";
      }
    })
    .catch((err) => console.error("Errore nella ricerca Algolia:", err));
}

function initAlgoliaDoubleQuery() {
  const searchClient = window.algoliaShopify?.instantsearch?.search?.client;
  if (!searchClient) {
    setTimeout(initAlgoliaDoubleQuery, 400);
    return;
  }
  if (window.location.pathname.includes("/collections/")) {
    document.querySelectorAll(".ais-h2").forEach((el) => {
      el.style.display = "none";
    });
  }
  fetchAndRenderHits();
}

document.addEventListener("DOMContentLoaded", initAlgoliaDoubleQuery);

function sortFacetOptions(facetName, type = "alpha") {
  const container = document.querySelector(
    `.ais-facet-${facetName}-container .ais-RefinementList-list`
  );
  if (!container) return;

  const items = Array.from(container.querySelectorAll("li"));

  const sorted = items.sort((a, b) => {
    const labelA = a.querySelector("label").textContent.trim();
    const labelB = b.querySelector("label").textContent.trim();

    if (type === "alpha") {
      return labelA.localeCompare(labelB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    } else if (type === "random") {
      return Math.random() - 0.5;
    }
  });

  container.innerHTML = "";
  sorted.forEach((li) => container.appendChild(li));
}

document.addEventListener("algolia.hooks.initialize", function () {
  const searchbox = document.getElementById("algolia-shopify-instantsearch");

  setTimeout(() => {
    if (searchbox) {
      searchbox.classList.add("algolia-ready");
    }
    sortFacetOptions("meta\\.custom\\.format", "alpha");
    sortFacetOptions("meta\\.custom\\.select_stagionatura", "alpha");
    sortFacetOptions("vendor", "random");
  }, 400);

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchOptions",
    function (options) {
      return {
        ...options,
        hitsPerPage: 12, // o un numero adatto per includere tutti i prodotti del vendor preferito
      };
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteFiltersString",
    function (filters) {
      const marketAttribute = marketAttributeMap[currentMarketHandle];

      if (marketAttribute) {
        // se ci sono già altri filtri li concateno con AND
        return filters
          ? `${filters} AND ${marketAttribute}:true`
          : `${marketAttribute}:true`;
      }

      return filters;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchStatsTemplate",
    function (stats, searchResults) {
      const totalHits = searchResults?.nbHits ?? 0;
      const hitsPerPage = searchResults?.hitsPerPage ?? 0;
      const currentPage = searchResults?.page ?? 0;
      const loadedHits = hitsPerPage * (currentPage + 1);

      const resultsContainer = document.getElementById("algolia-results-count");
      if (resultsContainer) resultsContainer.innerHTML = " " + totalHits;

      const loadMoreBtn = document.getElementById("load-more-products");
      if (loadMoreBtn) {
        if (loadedHits >= totalHits) {
          loadMoreBtn.style.display = "none";
        } else {
          loadMoreBtn.style.display = "block";
        }
      }
      return stats;
    }
  );

  algoliaShopify.hooks.registerHook("beforeISTransformItems", function () {
    const args = Array.prototype.slice.call(arguments);
    const items = args[args.length - 1];

    if (!Array.isArray(items)) return items;

    if (!customerFavouriteVendor) return items;

    const vendorItems = items.filter(
      (h) => h.vendor === customerFavouriteVendor
    );
    const otherItems = items.filter(
      (h) => h.vendor !== customerFavouriteVendor
    );

    return [...vendorItems, ...otherItems];
  });

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFacetItemTemplate",
    function (_defaultTemplate, item, html) {
      return html`
        <label class="${item.cssClasses.label} algolia-checkbox-wrapper">
          <input
            type="checkbox"
            class="algolia-custom-checkbox"
            value="${item.value}"
            data-facet="${item.attribute}"
            name="${item.attribute}"
          />
          <span class="checkmark"></span>
          ${translateUI(item.label)}
        </label>
      `;
    }
  );

  window.updateCheckboxesUI = function () {
    const checkboxes = document.querySelectorAll(
      'input[type="checkbox"][data-facet]'
    );

    const filterCount = document.getElementById("filterCount");

    const totalSelected = Object.values(selectedFilters).reduce(
      (sum, arr) => sum + arr.length,
      0
    );

    if (totalSelected > 0) {
      filterCount.style.display = "inline";
      filterCount.textContent = `(${totalSelected})`;
    } else {
      filterCount.style.display = "none";
    }

    checkboxes.forEach((checkbox) => {
      const facet = checkbox.getAttribute("data-facet");
      const value = checkbox.value;
      const isActive =
        selectedFilters[facet] && selectedFilters[facet].includes(value);
      checkbox.checked = isActive;
    });
  };

  function updateSelectedFiltersLabels() {
    const container = document.querySelector(".selectedFiltersLabelsContainer");
    if (!container) return;
    const filterActiveLabels = document.querySelector(
      ".selected-filters-labels-title"
    );
    filterActiveLabels.classList.toggle(
      "hidden",
      Object.keys(selectedFilters).length === 0
    );
    container
      .querySelectorAll(".selected-filter-label")
      .forEach((el) => el.remove());

    Object.entries(selectedFilters).forEach(([facetName, values]) => {
      values.forEach((value) => {
        const label = document.createElement("span");
        label.className = "selected-filter-label";
        label.textContent = translateUI(value);

        const closeBtn = document.createElement("button");
        closeBtn.className = "selected-filter-label-close";
        closeBtn.innerHTML = "&times;";
        closeBtn.title = `${translateUI("Rimuovi filtro")} ${value}`;
        closeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          // Rimuovi filtro specifico
          const index = selectedFilters[facetName].indexOf(value);
          if (index > -1) {
            selectedFilters[facetName].splice(index, 1);
            if (selectedFilters[facetName].length === 0) {
              delete selectedFilters[facetName];
            }
          }
          updateSelectedFiltersLabels();
        });

        label.insertBefore(closeBtn, label.firstChild);
        container.appendChild(label);
      });
    });

    const removeFiltersContainer = document.querySelector(".removeAllFilters");
    let clearBtn = document.getElementById("clearAllFiltersBtn");

    if (Object.keys(selectedFilters).length > 0) {
      if (!clearBtn) {
        clearBtn = document.createElement("button");
        clearBtn.id = "clearAllFiltersBtn";
        clearBtn.textContent = translateUI("Rimuovi tutti");
        clearBtn.className = "clear-all-filters-button";

        clearBtn.style.display = "block";
        clearBtn.style.width = "100%";
        clearBtn.style.marginTop = "10px";

        clearBtn.addEventListener("click", () => {
          for (const key in selectedFilters) {
            delete selectedFilters[key];
          }
          updateCheckboxesUI();
          updateSelectedFiltersLabels();
        });

        if (removeFiltersContainer) {
          removeFiltersContainer.appendChild(clearBtn);
        }
      }
    } else {
      if (clearBtn) clearBtn.remove();
    }
  }

  function blockAlgoliaDefaultEvents() {
    document.addEventListener(
      "click",
      function (e) {
        const item = e.target.closest(".ais-RefinementList-item");
        if (!item) return;
        e.preventDefault();
        e.stopImmediatePropagation();

        item.classList.toggle("selected-temp");

        const facetName = getFacetNameFromItem(item);
        if (!facetName) return;
        function cleanFilterValue(rawValue) {
          return rawValue.replace(/\d+$/, "").trim();
        }

        const rawValue = item
          .querySelector(".ais-RefinementList-label")
          .textContent.trim();
        const filterValue = cleanFilterValue(rawValue);

        const originalValue = getOriginalValue(filterValue);
        if (!selectedFilters[facetName]) selectedFilters[facetName] = [];

        const index = selectedFilters[facetName].indexOf(originalValue);
        if (index > -1) {
          selectedFilters[facetName].splice(index, 1);
        } else {
          selectedFilters[facetName].push(originalValue);
        }

        if (selectedFilters[facetName].includes(originalValue)) {
          item.classList.add("selected-algolia-filter");
        } else {
          item.classList.remove("selected-algolia-filter");
        }
        updateCheckboxesUI();
        updateSelectedFiltersLabels(); // <--- qui la chiamata
      },
      true
    );
  }

  function getFacetNameFromItem(item) {
    let el = item.parentElement;
    while (el) {
      const facetClass = Array.from(el.classList).find(
        (c) => c.startsWith("ais-facet-") && !c.startsWith("ais-facet--")
      );
      if (facetClass) {
        return facetClass.replace("ais-facet-", "").replace("-container", "");
      }
      el = el.parentElement;
    }
    return null;
  }

  function loadMoreHits() {
    const searchClient = window.algoliaShopify?.instantsearch?.search?.client;
    if (!searchClient) return;

    const indexName = getCurrentSortIndex();

    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get("q") || "";

    const filtersArray = [];
    Object.entries(selectedFilters).forEach(([facetName, values]) => {
      if (values.length) {
        const escapedValues = values.map((v) => v.replace(/"/g, '\\"'));
        const facetFilters = escapedValues.map(
          (value) => `${facetName}:"${value}"`
        );
        filtersArray.push(`(${facetFilters.join(" OR ")})`);
      }
    });

    const marketAttribute = marketAttributeMap[currentMarketHandle];
    if (marketAttribute) {
      filtersArray.push(`${marketAttribute}:true`);
    }

    const collectionFilter = window.currentCollectionFilter || null;
    if (collectionFilter) {
      filtersArray.push(collectionFilter);
    }
    const baseFilters = filtersArray.join(" AND ");

    currentHitsPerPage += 12;

    const vendor = customerFavouriteVendor || null;
    const escVendor = vendor ? String(vendor).replace(/"/g, '\\"') : null;

    const queries = [];

    if (escVendor) {
      const hasVendorInBase = /(^|\s|\()vendor:/.test(baseFilters);
      const vendorFilters = baseFilters
        ? hasVendorInBase
          ? baseFilters
          : `(${baseFilters}) AND vendor:"${escVendor}"`
        : `vendor:"${escVendor}"`;

      queries.push({
        indexName,
        params: {
          query,
          filters: vendorFilters,
          hitsPerPage: currentHitsPerPage,
        },
      });
    }

    queries.push({
      indexName,
      params: {
        query,
        filters: baseFilters || "",
        hitsPerPage: currentHitsPerPage,
      },
    });

    searchClient
      .search(queries)
      .then(({ results }) => {
        let merged = [];
        let nbHits = 0;

        if (escVendor) {
          const vendorHits = results[0]?.hits || [];
          const mainRes = results[1];
          const mainHits = mainRes?.hits || [];

          const seen = new Set();
          const pushUnique = (arr) => {
            for (const h of arr) {
              const id =
                h.objectID ||
                h.objectId ||
                h.id ||
                `${h.vendor}-${h.handle || h.title}`;
              if (!seen.has(id)) {
                seen.add(id);
                merged.push(h);
              }
            }
          };

          pushUnique(vendorHits);
          pushUnique(mainHits);

          merged = merged.slice(0, currentHitsPerPage);

          nbHits =
            typeof mainRes?.nbHits === "number"
              ? mainRes.nbHits
              : merged.length;
        } else {
          const mainRes = results[0];
          merged = (mainRes?.hits || []).slice(0, currentHitsPerPage);
          nbHits =
            typeof mainRes?.nbHits === "number"
              ? mainRes.nbHits
              : merged.length;
        }

        renderHits(merged);

        const resultsContainer = document.getElementById(
          "algolia-results-count"
        );
        if (resultsContainer) resultsContainer.textContent = " " + nbHits;

        const loadMoreButton = document.querySelector("#load-more-products");
        if (loadMoreButton) {
          loadMoreButton.style.display =
            currentHitsPerPage >= nbHits ? "none" : "block";
        }
      })
      .catch((err) =>
        console.error("Errore nel caricamento di più hits:", err)
      );
  }

  function applySelectedFilters() {
    const searchClient = window.algoliaShopify?.instantsearch?.search?.client;
    if (!searchClient) {
      console.error("Search client Algolia non trovato!");
      return;
    }

    const indexName =
      window.algoliaShopify?.instantsearch?.search?.indexName || "products";

    const query =
      new URLSearchParams(window.location.search).get("q") ??
      document.querySelector(".ais-search-box input")?.value.trim() ??
      "";

    const filtersArray = [];
    const vendorFiltersSelected = [];

    Object.entries(selectedFilters).forEach(([facetName, values]) => {
      if (Array.isArray(values) && values.length) {
        let escapedValues = values.map((v) => v.replace(/"/g, '\\"'));
        if (facetName === "vendor") {
          const fav = customerFavouriteVendor;
          if (fav) {
            const favEsc = String(fav).replace(/"/g, '\\"');
            const idx = escapedValues.findIndex(
              (v) => v.toLowerCase() === favEsc.toLowerCase()
            );
            if (idx > -1) {
              const [favVendor] = escapedValues.splice(idx, 1);
              escapedValues.unshift(favVendor);
            }
          }
          vendorFiltersSelected.push(
            `(${escapedValues.map((v) => `vendor:"${v}"`).join(" OR ")})`
          );
        } else {
          filtersArray.push(
            `(${escapedValues.map((v) => `${facetName}:"${v}"`).join(" OR ")})`
          );
        }
      }
    });

    const collectionFilter = window.currentCollectionFilter || null;
    if (collectionFilter) filtersArray.push(collectionFilter);

    const marketAttribute = marketAttributeMap[currentMarketHandle];
    if (marketAttribute) {
      filtersArray.push(`${marketAttribute}:true`);
    }
    const baseFilters = filtersArray.join(" AND ");
    const vendorClause = vendorFiltersSelected.join(" AND ");
    const userHasVendor = vendorFiltersSelected.length > 0;

    const favVendor = customerFavouriteVendor
      ? String(customerFavouriteVendor).replace(/"/g, '\\"')
      : null;

    const queries = [];

    if (userHasVendor) {
      const combined = [baseFilters, vendorClause]
        .filter(Boolean)
        .join(" AND ");
      queries.push({
        indexName,
        params: {
          query,
          filters: combined,
          hitsPerPage: currentHitsPerPage,
        },
      });
    } else if (favVendor) {
      const filtersWithFav = baseFilters
        ? `(${baseFilters}) AND vendor:"${favVendor}"`
        : `vendor:"${favVendor}"`;

      queries.push({
        indexName,
        params: {
          query,
          filters: filtersWithFav,
          hitsPerPage: currentHitsPerPage,
        },
      });

      queries.push({
        indexName,
        params: {
          query,
          filters: baseFilters || "",
          hitsPerPage: currentHitsPerPage,
        },
      });
    } else {
      // Nessun vendor preferito e nessun vendor selezionato → query semplice
      queries.push({
        indexName,
        params: {
          query,
          filters: baseFilters || "",
          hitsPerPage: currentHitsPerPage,
        },
      });
    }

    searchClient
      .search(queries)
      .then(({ results }) => {
        let hits = [];
        let nbHits = 0;

        if (!userHasVendor && favVendor && results.length > 1) {
          const seen = new Set();
          const pushUnique = (arr) => {
            for (const h of arr) {
              const id =
                h.objectID || h.id || `${h.vendor}-${h.handle || h.title}`;
              if (!seen.has(id)) {
                seen.add(id);
                hits.push(h);
              }
            }
          };
          pushUnique(results[0].hits || []);
          pushUnique(results[1].hits || []);
          hits = hits.slice(0, currentHitsPerPage);
          nbHits = results[1].nbHits ?? hits.length;
        } else {
          const mainRes = results[0];
          hits = (mainRes?.hits || []).slice(0, currentHitsPerPage);
          nbHits = mainRes?.nbHits ?? hits.length;
        }

        renderHits(hits);

        const resultsContainer = document.getElementById(
          "algolia-results-count"
        );
        if (resultsContainer) resultsContainer.textContent = " " + nbHits;

        const loadMoreBtn = document.getElementById("load-more-products");
        if (loadMoreBtn) {
          loadMoreBtn.style.display =
            currentHitsPerPage >= nbHits ? "none" : "block";
        }
      })
      .catch((err) => console.error("Errore nella ricerca Algolia:", err));
  }

  document.addEventListener("DOMContentLoaded", () => {
    blockAlgoliaDefaultEvents();
    updateSelectedFiltersLabels();
    const mostraBtn = document.querySelector(".algolia-search-button");
    if (mostraBtn) {
      mostraBtn.addEventListener("click", applySelectedFilters);
    }
  });

  const url = new URL(window.location.href);
  const search_term_string = url.searchParams.get("q");
  const closeImage = window.closeImage;
  blockAlgoliaDefaultEvents();

  const observer = new MutationObserver(() => {
    const nativeSelect = document.querySelector(
      ".ais-sort-orders-container select"
    );
    const customMenu = document.querySelector("#sortCustomMenu");
    const toggleBtn = document.querySelector("#sortToggleBtn");
    const chevron = toggleBtn?.querySelector(".chevron");

    if (nativeSelect && customMenu) {
      customMenu.innerHTML = "";
      [...nativeSelect.options].slice(1).forEach((opt) => {
        const li = document.createElement("li");
        li.textContent = opt.textContent;
        li.dataset.value = opt.value;

        if (opt.selected) li.classList.add("active");

        li.addEventListener("click", () => {
          nativeSelect.value = opt.value;
          nativeSelect.dispatchEvent(new Event("change"));

          customMenu
            .querySelectorAll("li")
            .forEach((li) => li.classList.remove("active"));
          li.classList.add("active");
          customMenu.classList.add("hidden");
          chevron.classList.remove("open");

          document.body.style.overflow = "";
          document.body.style.height = "";

          fetchAndRenderHits();
        });

        customMenu.appendChild(li);
      });

      toggleBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const isHidden = customMenu.classList.contains("hidden");
        customMenu.classList.toggle("hidden");
        chevron.classList.toggle("open");

        if (isHidden) {
          document.body.style.overflow = "hidden";
          document.body.style.height = "100vh";
          document.body.style.paddingRight = "0";
        } else {
          document.body.style.overflow = "";
          document.body.style.height = "";
          document.body.style.paddingRight = "0";
        }
      });

      document.addEventListener("click", (e) => {
        if (!toggleBtn.contains(e.target) && !customMenu.contains(e.target)) {
          if (!customMenu.classList.contains("hidden")) {
            customMenu.classList.add("hidden");
            chevron.classList.remove("open");
            document.body.style.overflow = "";
            document.body.style.height = "";
            document.body.style.paddingRight = "0";
          }
        }
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    function (_defaultTemplate, data, html) {
      return html`
        <div class="search-page">
          <h1 class="ais-h2">
            ${translateUI("Risultati di ricerca per")}:
            "${search_term_string || ""}"
          </h1>
          <div class="algolia-custom-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>

          <div class="algolia-custom-banner">
            <button id="openModalBtn">
              ${window.filterFor}
              <span id="filterCount" style="display:none;">(0)</span>
              <svg
                width="18"
                height="18"
                style="rotate: 270deg;"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9l6 6 6-6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <div class="dropdown-wrapper">
              <button id="sortToggleBtn" class="ais-sort">
                <span id="sortSelectedLabel"
                  >${window.orderFor}
                  <svg
                    class="chevron"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>

              <ul id="sortCustomMenu" class="hidden"></ul>

              <div style="display:none;">
                <span class="ais-sort-orders-container"></span>
              </div>
            </div>
          </div>

          <div class="ais-facets-button algolia-custom-facets-button">
            ${algoliaShopify.translations.showFilters}
          </div>

          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span
                  class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
            </div>
            <div id="algolia-results-counter">
              <span id="algolia-main-cart-items-label">
                ${window.mainCartItemsLabel
                  ? window.mainCartItemsLabel.charAt(0).toUpperCase() +
                    window.mainCartItemsLabel.slice(1)
                  : "Articoli"}
              </span>
              ${" "}1-
              <span id="algolia-partial-count"></span>
              di
              <span id="algolia-results-count"></span>
            </div>

            <div class="algolia-results-container">
              <div class="ais-hits-container ais-results-as-block"></div>
              <div class="algolia-load-more-wrapper">
                <button
                  onclick="${() => loadMoreHits()}"
                  id="load-more-products"
                >
                  ${window.showMoreProducts}
                </button>
              </div>
            </div>
          </div>

          <div class="ais-pagination-container"></div>
          <div id="algolia-fallback-container"></div>
          <div id="algoliaFilter-overlay" class="algoliaFilter-overlay hidden">
            <div id="customModalAlgolia" class="customModalAlgolia">
              <div class="customModalAlgolia-header">
                <div>${window.filterFor}</div>
                <button class="modal-close-btn">
                  <img
                    id="closeModalBtn"
                    src="${closeImage}"
                    width="14"
                    height="14"
                    alt="close"
                  />
                </button>
              </div>

              <div class="algolia-modal-list">
                <div class="ais-facets">
                  <div class="ais-clear-refinements-container"></div>
                  <div class="ais-current-refined-values-container"></div>
                  <div class="selectedFiltersLabelsContainer">
                    <span class="selected-filters-labels-title hidden"
                      >${translateUI("FILTRI ATTIVI")}:</span
                    >
                  </div>
                  <div class="removeAllFilters"></div>
                  ${data.facets.map(
                    (facet) => html`
                      <div
                        class="algolia-collapsible ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                      >
                        <button class="algolia-collapsible__header">
                          ${translateUI(facet.title)}
                          <div class="algolia-collapsible__header__chevron">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M6 9l6 6 6-6"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </button>

                        <div class="algolia-collapsible__content hidden">
                          <div
                            class="algolia-facet-container ais-facet-${facet.escapedName}-container"
                          ></div>
                        </div>
                      </div>
                    `
                  )}
                </div>
              </div>
              <div class="algolia-search-wrapper">
                <button class="algolia-search-button">${window.show}</button>
              </div>
            </div>
          </div>
        </div>
      `;
    }
  );

  // Modal e chiusura
  document.addEventListener("click", function (e) {
    const modal = document.getElementById("customModalAlgolia");
    const overlay = document.getElementById("algoliaFilter-overlay");
    const sortMenu = document.getElementById("sortDropdownMenu");
    const searchButton = document.querySelector(".algolia-search-button");
    function openModal() {
      document.body.appendChild(overlay);

      modal.classList.remove("animate-out");
      modal.classList.add("animate-in");
      modal.style.display = "flex";
      overlay.classList.remove("hidden");
      document.body.classList.add("no-scroll");
      document.body.style.overflow = "hidden";
    }

    function closeModal() {
      modal.classList.remove("animate-in");
      modal.classList.add("animate-out");
      modal.addEventListener("animationend", function handler() {
        modal.style.display = "none";
        overlay.classList.add("hidden");
        document.body.style.overflow = "";
        modal.removeEventListener("animationend", handler);
      });
    }

    if (e.target && e.target.id === "openModalBtn") openModal();
    if (e.target && e.target.id === "closeModalBtn") closeModal();
    if (e.target && e.target.id === "algoliaFilter-overlay") closeModal();
    if (e.target && e.target.id === "sortDropdownBtn") {
      sortMenu.style.display =
        sortMenu.style.display === "block" ? "none" : "block";
    } else if (!e.target.closest(".dropdown-wrapper")) {
      if (sortMenu) sortMenu.style.display = "none";
    }

    if (e.target && e.target.classList.contains("algolia-search-button")) {
      applySelectedFilters();
      closeModal();
    }
  });

  // Comportamento collapsible
  document.addEventListener("click", function (e) {
    const header = e.target.closest(".algolia-collapsible__header");
    if (header) {
      header.classList.toggle("collapsed");
      const content = header.parentElement.querySelector(
        ".algolia-collapsible__content"
      );
      content.style.borderBottom = "1px solid #8888";
      content.style.paddingBottom = "10px";
      const chevronImage = header.querySelector(
        ".algolia-collapsible__header__chevron"
      );
      chevronImage.classList.toggle("isOpen");
      if (content) content.classList.toggle("hidden");
    }
  });

  function addVendorSearchInput() {
    const vendorFacetContainer = document.querySelector(
      ".ais-facet-vendor-container"
    );
    const vendorCollapsible = document.querySelector(
      ".algolia-collapsible__header"
    );
    const collapsibleContent = vendorCollapsible?.nextElementSibling;

    if (!vendorFacetContainer || !vendorCollapsible || !collapsibleContent)
      return;

    // Evita duplicati
    if (vendorFacetContainer.querySelector(".vendor-search-wrapper")) return;

    // Crea wrapper div
    const wrapper = document.createElement("div");
    wrapper.className = "input-with-icon vendor-search-wrapper";

    // Crea input
    const input = document.createElement("input");
    input.type = "text";
    input.className = "vendor-search-input";
    input.placeholder = translateUI("Cerca...");
    input.style.marginRight = "20px";

    // Crea div per SVG
    const iconWrapper = document.createElement("img");
    iconWrapper.className = "input-search-icon";
    iconWrapper.src = window.searchGradientModal;

    // Appendi input e svg
    wrapper.appendChild(input);
    wrapper.appendChild(iconWrapper);
    vendorFacetContainer.prepend(wrapper);

    // Filtro dinamico
    input.addEventListener("input", () => {
      const filterText = input.value.toLowerCase();
      const items = vendorFacetContainer.querySelectorAll(
        ".ais-RefinementList-item"
      );

      items.forEach((item) => {
        const label = item.querySelector(".ais-RefinementList-label");
        if (!label) return;

        const text = label.textContent.toLowerCase();
        item.style.display = text.includes(filterText) ? "" : "none";
      });
    });
  }

  // Richiama dopo un leggero delay
  setTimeout(addVendorSearchInput, 500);

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      const hitImage = algoliaShopify.helpers.renderImage(hit, 400);

      const handleize = (text) => {
        if (!text) return "";
        return text
          .toString()
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      };

      // codice per aggiungere al carrello
      if (!window.addToCartListenerAdded) {
        window.addToCartListenerAdded = true;

        document.body.addEventListener("click", (event) => {
          const addBtn = event.target.closest(".add-to-cart-button");
          if (!addBtn || addBtn.classList.contains("gift-card-button")) return;
          if (addBtn) {
            event.preventDefault();

            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: addBtn.dataset.variantId,
                quantity: 1,
              }),
            })
              .then((response) => {
                if (!response.ok)
                  throw new Error("Errore aggiunta al carrello");
                return response.json();
              })
              .then((data) => {
                const popup = document.getElementById("popup-notification");
                const message = document.getElementById("popup-message");
                const closeBtn = document.getElementById("popup-close");
                const counterSpan = document.getElementById("popup-counter");
                window.dataLayer = window.dataLayer || [];
                const cartData = window.GTMData.value;
                const productName = data.product_title;
                const price = data.price / 100;
                const quantity = data.quantity || 1;
                const currency = data.currency || "EUR";
                const maxPrice = data.original_price / 100 || price;
                const finalPrice = price;
                let discount = 0;
                if (hit.compare_at_price && hit.compare_at_price > hit.price) {
                  discount = hit.compare_at_price - hit.price;
                }
                const item = {
                  item_id: data.sku,
                  item_name: productName,
                  item_brand: data.vendor || "",
                  price: price,
                  quantity: quantity,
                  discount: discount,
                };

                const addToCartEvent = {
                  event: "add_to_cart",
                  ecommerce: {
                    currency: currency,
                    value: cartData,
                    items: [item],
                  },
                };
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(addToCartEvent);
                console.log(
                  "add_to_cart event pushed to dataLayer:",
                  addToCartEvent
                );
                message.textContent = `${hit.title}`;

                popup.classList.remove("hidden");

                let secondsRemaining = 4;
                counterSpan.textContent = secondsRemaining;

                const countdownInterval = setInterval(() => {
                  secondsRemaining--;
                  if (secondsRemaining <= 0) {
                    clearInterval(countdownInterval);
                  } else {
                    counterSpan.textContent = secondsRemaining;
                  }
                }, 1000);

                const timeoutId = setTimeout(() => {
                  clearInterval(countdownInterval);
                  popup.classList.add("hidden");
                }, secondsRemaining * 1000);

                closeBtn.onclick = () => {
                  clearInterval(countdownInterval);
                  clearTimeout(timeoutId);
                  popup.classList.add("hidden");
                };

                return fetch("/cart.js").then((res) => res.json());
              })
              .then((cart) => {
                const cartCountBubbleContainer =
                  document.querySelector(".cart-count-bubble");
                const cartCountBubble = document.querySelector(
                  "#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']"
                );
                const visuallyHidden = document.querySelector(
                  "#cart-icon-bubble .cart-count-bubble .visually-hidden"
                );
                const cartDrawer = document.getElementById(
                  "CartDrawerContainer"
                );
                const cartDrawerEmptyContainer = document.querySelector(
                  ".drawer__inner-empty"
                );
                if (
                  cartCountBubble &&
                  visuallyHidden &&
                  cartCountBubbleContainer
                ) {
                  cartCountBubbleContainer.style.display =
                    cart.item_count > 0 ? "flex" : "none";

                  cartCountBubble.textContent = cart.item_count;
                  visuallyHidden.textContent = `${cart.item_count} ${
                    window.mainCartItemsLabel || "articoli"
                  }`;
                }

                const cartDrawerButton = document.getElementById(
                  "CartDrawer-Form-Cta"
                );

                if (
                  cartDrawer &&
                  cartDrawerEmptyContainer &&
                  cartDrawerButton
                ) {
                  cartDrawer.classList.remove("is-empty");
                  cartDrawerEmptyContainer.style.display = "none";
                  cartDrawerButton.removeAttribute("disabled");
                }
                const drawerHeading = document.querySelector(
                  ".cart-drawer__heading"
                );
                if (drawerHeading) {
                  const singleText = drawerHeading.dataset.i18nSingle;
                  const multipleText = drawerHeading.dataset.i18nMultiple;

                  const text =
                    cart.item_count === 1
                      ? singleText.replace("{{ count }}", cart.item_count)
                      : multipleText.replace("{{ count }}", cart.item_count);

                  drawerHeading.textContent = text;
                }

                if (
                  typeof publish !== "undefined" &&
                  typeof PUB_SUB_EVENTS !== "undefined"
                ) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "pr-card-product",
                    cartData: cart,
                  });
                }
              })
              .catch((err) => alert(err.message));

            return;
          }
        });
      }

      setTimeout(() => {
        const addToCartButtons = document.querySelectorAll(
          ".algolia-add-to-cart-button"
        );

        addToCartButtons.forEach((button) => {
          button.addEventListener("focus", () => {
            document
              .querySelectorAll(".algolia-card-product")
              .forEach((card) => {
                card.classList.remove("active-add-to-cart");
              });
            const card = button.closest(".algolia-card-product");
            if (card) {
              card.classList.add("active-add-to-cart");
            }
          });

          button.addEventListener("blur", () => {
            const card = button.closest(".algolia-card-product");
            if (card) {
              card.classList.remove("active-add-to-cart");
            }
          });
        });
      }, 0);

      return html`
        <div class="algolia-pr-card-wrapper">
          ${(() => {
            const badges = hit.meta?.custom?.marchi_stagionatura;
            if (Array.isArray(badges) && badges.length > 0) {
              return html`
                <div class="algolia-card-product-badges">
                  ${badges.map((badge) => {
                    const url = window.assetBadgeMap?.[badge];
                    return url
                      ? html`
                          <img
                            src="${url}"
                            alt="${badge}"
                            class="algolia-badge-image"
                            loading="lazy"
                            width="64"
                            height="64"
                          />
                        `
                      : "";
                  })}
                </div>
              `;
            }
            return "";
          })()}
          <div
            class="algolia-card-product"
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
            onclick="${() => trackSearchAttribution(hit)}"
          >
            <div class="algolia-card-body">
              <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                <img
                  class="algolia-card-product-img"
                  src="${hitImage.src}"
                  srcset="${hitImage.srcset}"
                  sizes="${hitImage.sizes}"
                  alt="${hit.title}"
                  width="100%"
                  height="100%"
                />
              </a>

              ${(() => {
                const formatRaw = hit.meta?.custom?.format;
                const formatString =
                  typeof formatRaw === "string"
                    ? formatRaw
                    : String(formatRaw ?? "");
                const match = formatString.match(/([\d.,]+)/);
                if (match) {
                  const kg = parseFloat(match[1].replace(",", "."));
                  if (kg >= 4) {
                    return html`
                      <div class="algolia-card-product-tag">
                        ${translateUI("Grandi formati")}
                      </div>
                    `;
                  }
                }
                return "";
              })()}

              <div class="algolia-product-card-info">
                ${(() => {
                  const isGiftCard =
                    hit.meta?.custom?.tipo_prodotto == "Carte Regalo";
                  if (isGiftCard) return "";
                  return html` <div class="algolia-card-product-vendor">
                    <a
                      href="${window.collectionsBaseUrl}/${handleize(
                        hit.vendor
                      )}"
                    >
                      ${components.Highlight({ attribute: "vendor", hit })}
                    </a>
                  </div>`;
                })()}

                <div class="algolia-card-product-title">
                  <a href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    >${hit.title}</a
                  >
                </div>

                <div class="algolia-price-per-kg">
                  ${(() => {
                    let prezzoAlKg = "";
                    const weight = hit.grams;
                    const finalPrice =
                      Shopify.locale === "it"
                        ? hit?.meta?.custom?.prezzo_catalogo_ita
                        : hit?.meta?.custom?.prezzo_catalogo_eu;
                    if (
                      hit.product_type !== "kit" &&
                      typeof weight === "number" &&
                      weight > 0 &&
                      typeof finalPrice === "number" &&
                      finalPrice > 0
                    ) {
                      const prezzoAlKgNum = (finalPrice * 1000) / weight;
                      prezzoAlKg = `${prezzoAlKgNum
                        .toFixed(2)
                        .replace(".", ",")}€/kg`;
                    }
                    return html`${prezzoAlKg}`;
                  })()}
                </div>

                ${(() => {
                  const minPrice = hit.meta?.custom?.omnibus_min_price;
                  const discount =
                    hit.meta?.custom?.omnibus_discount_percentage;
                  if (minPrice || discount) {
                    return html`
                      <div class="algolia-last-best-price">
                        ${translateUI("Prezzo più basso recente")}:
                        <span class="algolia-value"
                          >€${parseFloat(minPrice).toFixed(2)}</span
                        >
                        <span class="algolia-percentage"
                          >${discount ?? ""}</span
                        >
                      </div>
                    `;
                  }

                  return "";
                })()}
              </div>
            </div>
            <div class="algolia-card-product-bottom">
              <div class="algolia-product-price">
                ${Shopify.locale === "it"
                  ? algoliaShopify.helpers.displayPrice(hit, hit._distinct)
                  : `€${parseFloat(
                      hit?.meta?.custom?.prezzo_catalogo_eu ?? 0
                    ).toFixed(2)}`.replace(".", ",")}
              </div>
              <div class="algolia-product-weight">
                ${(() => {
                  const raw = hit.weight;
                  const isGiftCard =
                    hit.meta?.custom?.tipo_prodotto == "Carte Regalo";

                  if (isGiftCard) return "";

                  if (typeof raw === "string") {
                    const match = raw.match(/^([\d.]+)([a-zA-Z]+)$/);
                    if (match) {
                      const number = Math.floor(parseFloat(match[1]));
                      const unit = match[2];
                      return `${number}${unit}`;
                    }
                    return raw;
                  }

                  if (typeof raw === "number") {
                    return `${Math.floor(raw)}g`;
                  }

                  return "";
                })()}
              </div>
            </div>

            ${(() => {
              const isGiftCard =
                hit.meta?.custom?.tipo_prodotto == "Carte Regalo";
              const productLink = algoliaShopify.helpers.instantsearchLink(hit);
              if (isGiftCard)
                return html`
                    <a
                      href="${productLink}"
                      class="algolia-add-to-cart-button add-to-cart-button gift-card-button"
                      role="button"
                    >
                      ${window.chooseGiftCard}
                    </a`;
              return html`
                   <button
                    class="algolia-add-to-cart-button add-to-cart-button"
                    type="button"
                    data-product-id="${hit.id}"
                    data-variant-id="${hit.objectID}"
                  >
                    ${window.addToCart}
                  </button`;
            })()}
          </div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      options.placeholder = window.searchPlaceholder || "Search our products";
      options.detachedMediaQuery = "none";
      return options;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteHeaderTemplate",
    function (_defaultTemplate, templateOptions, resource) {
      const { html } = templateOptions;
      return html``;
    }
  );

  /*algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;

      // Nascondi i prezzi autocomplete se il mercato non è italiano
      if (Shopify.country?.toLowerCase() !== "it") {
        setTimeout(() => {
          document
            .querySelectorAll(".aa-ItemContentPrice")
            .forEach(function (el) {
              el.style.display = "none";
            });
        }, 0);
      }

      return html`
        <div class="algolia-PanelLayout algolia-Panel--scrollable">
          <div class="algolia-PanelSections">
            <div class="algolia-SourceHeader">
              <span class="algolia-SourceHeaderTitle">
                ${window.products}
              </span>
            </div>

            <div class="algolia-PanelSection--left">${elements.products}</div>

            <div class="algolia-PanelSection--right">
              ${elements.querySuggestionsPlugin}
            </div>

            <div class="algolia-SourceHeader">
              <span class="algolia-SourceHeaderTitle"> ${window.vendors} </span>
            </div>

            ${elements.collections}
          </div>
        </div>
      `;
    }
  );*/

  /*algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;
      return html`
        <div class="algolia-PanelLayout algolia-Panel--scrollable">
          <div class="algolia-PanelSections">
            <div class="algolia-SourceHeader">
              <span class="algolia-SourceHeaderTitle">
                ${window.products}
              </span>
            </div>

            <div class="algolia-PanelSection--left">
              ${window.noProduct} : ${state.query}
            </div>

            <div class="algolia-SourceHeader">
              <span class="algolia-SourceHeaderTitle"> ${window.vendors} </span>
            </div>
          </div>
        </div>
      `;
    }
  );*/

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchNoResultTemplate",
    function (_defaultTemplate, html) {
      return html`
        <div class="ais-hit-empty">
          <div class="ais-hit-empty--title">
            ${algoliaShopify.translations.noResultFound}
          </div>
          <div class="ais-hit-empty--clears">
            ${algoliaShopify.translations.try} ${" "}
            <a class="ais-hit-empty--clear-filters ais-link">
              ${algoliaShopify.translations.clearFilters} ${" "}
            </a>
            ${algoliaShopify.translations.or} ${" "}
            <a class="ais-hit-empty--clear-input ais-link">
              ${algoliaShopify.translations.changeInput}
            </a>
          </div>
        </div>
      `;
    }
  );
});
